/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";

import Stack from "@mui/material/Stack";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import LockIcon from "@mui/icons-material/Lock";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import AddRole from "./add-update-role/index";
import Div from "@jumbo/shared/Div";
import {
  createRole,
  deleteRole,
  getRoleList,
  updateRole,
} from "app/redux/slice/roleSlice";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Loader from "@jumbo/components/Loader";
import { useNavigate } from "react-router-dom";
import { userType } from "app/helpers/userType";
import { managePermission } from "app/routes/constant";

const Role = () => {
  const { isOpen, onClose, onOpen, stageAction, actionProps } = useDisclosure();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isMA } = userType();

  const { enqueueSnackbar } = useSnackbar();
  const roleData = useSelector((state) => state?.role);
  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [isInitialized, setIsInitialized] = useState(false);

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "role" });
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    managePermission: false,
    deletePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        managePermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        managePermission: false,
        deletePermission: false,
      };

      permissionData?.length &&
        permissionData.forEach(function (num) {
          if (num?.name === "role-create") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "role-delete") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "role-update") {
            permissionValue.updatePermission = true;
          }
          if (num?.name === "permission-manage") {
            permissionValue.managePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  useEffect(() => {
    getPermission();

    const savedSearchText = localStorage.getItem("role-search") || "";
    setSearchText(savedSearchText);
    setIsInitialized(true);
  }, []);

  const columns = [
    { id: "name", label: "Role", sort: true },
    { id: "description", label: "Description", sort: true },
    {
      id: "actions",
      label: "Actions",
      align: "right",
      render: (row) => (
        <>
          {permission.updatePermission && (
            <IconButton
              onClick={() => {
                stageAction(row);
              }}
            >
              <EditIcon />
            </IconButton>
          )}
          {permission.managePermission && (
            <IconButton
              size="small"
              onClick={() => navigate(managePermission(row._id))}
            >
              <LockIcon fontSize="small" />
            </IconButton>
          )}
          {permission.deletePermission && (
            <IconButton
              onClick={() => {
                deleteStageAction(row);
              }}
            >
              <DeleteIcon color={"error"} />
            </IconButton>
          )}
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    const newTaxData = {
      name: data?.role?.trim(),
      description: data?.description?.trim(),
    };
    const response = await dispatch(
      actionProps?._id
        ? updateRole({ id: actionProps._id, data: newTaxData })
        : createRole(newTaxData)
    ).unwrap();
    if (response.status === 200) {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "success",
      });
      getData();
      onClose();
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
  };

  const DeleteRole = () => {
    dispatch(deleteRole(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("role-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getRoleList(value));
  };

  useEffect(() => {
    if (isInitialized) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, dispatch, order, orderBy, isInitialized]);

  useEffect(() => {
    if (isInitialized && searchText !== "") {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };
  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };
  return (
    <>
      {roleData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={10}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Roles & Permissions
                </Typography>
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      onOpen();
                    }}
                    sx={{
                      mt: { xs: 1, md: 0 },
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Add role
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={roleData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogDefault
            open={isOpen}
            onClose={onClose}
            content={
              <AddRole
                value={actionProps}
                onClose={onClose}
                handleSubmit={handleSubmit}
              />
            }
            title={actionProps?._id ? "Update Role" : "Add Role"}
            fullWidth={true}
            maxWidth={"sm"}
            actions={<></>}
          />
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the role?"
            onConfirm={DeleteRole}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default Role;
